<div class="closeCross">
  <span mat-dialog-title>{{ (config.onlyForDetails ? 'alreadyExistingTuition' : 'bookEmployeeToPersonalSchooling') | translate }}</span>
  <saf-bug-report-button></saf-bug-report-button>
  <mat-icon (click)="closeDialog($event)" class="cross">close</mat-icon>
</div>

<div class="container" fxLayout="column" fxLayoutGap="16px" fxLayoutGap.xs="8px">
  @if (!config.onlyForDetails) {
    <section class="header" fxLayout="row" fxLayoutGap="16px" fxLayoutGap.xs="8px">
      <button class="schooling" mat-raised-button color="primary" (click)="openTuitionDetails($event)">
        <mat-icon>add</mat-icon>
        <span>{{ 'create' | translate }}</span>
      </button>
    </section>
  }
  <div class="table-container" [fxShow]="dataSource.data.length">
    <table mat-table [dataSource]="dataSource" id="table" class="table" matSort matSortDirection="asc" matSortActive="topicName" [trackBy]="trackById">

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
        </th>
        <td mat-cell *matCellDef="let row" >
          @if (!config.onlyForDetails) {
            <mat-slide-toggle   [checked]="tuitionId === row.tuition.id" (change)="selectTuition($event, row)">
            </mat-slide-toggle>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="topicName">
        <th mat-header-cell *matHeaderCellDef disableClear mat-sort-header="topicName"
        >{{ 'topic' | translate }}</th>
        <td mat-cell *matCellDef="let listItem">
          <span >{{ listItem.topic.name }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="tuitionTime">
        <th mat-header-cell *matHeaderCellDef >{{ 'tuitionTime' | translate }}</th>
        <td mat-cell *matCellDef="let listItem">
          <span style="font-weight:{{listItem.tuition.tuitionTime === '00:00:00' ? 'bold' : ''}}">{{ listItem.tuition.tuitionTime === '00:00:00' ? ('noTime' | translate) : (listItem.tuition.tuitionTime | time) }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="createDate" >
        <th mat-header-cell *matHeaderCellDef disableClear mat-sort-header="createDate">{{ 'creatDate' | translate }}</th>
        <td mat-cell *matCellDef="let listItem">
          <span style="font-weight:{{listItem.tuition.tuitionDate ? '' : 'bold'}}">{{ listItem.tuition.createDate  ?
          (listItem.tuition.createDate | date) : ('noDate' | translate )}}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="creator">
        <th mat-header-cell *matHeaderCellDef >{{ 'creator' | translate }}</th>
        <td mat-cell *matCellDef="let listItem">
          <saf-employee-name [firstName]="listItem.assigneeEmployee.firstName"
                             [lastName]="listItem.assigneeEmployee.name"></saf-employee-name>
        </td>
      </ng-container>

      <ng-container matColumnDef="tuitionLocation">
        <th mat-header-cell *matHeaderCellDef >{{ 'location' | translate }}</th>
        <td mat-cell *matCellDef="let listItem">
          <span>{{ listItem.room ? listItem.location.name : '-'  }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="tuitionRoom">
        <th mat-header-cell *matHeaderCellDef >{{ 'room' | translate }}</th>
        <td mat-cell *matCellDef="let listItem">
          <span>{{ listItem.room ? listItem.room.name : '-'  }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="lectureName">
        <th mat-header-cell *matHeaderCellDef >{{ 'lecturerEmployee' | translate }}</th>
        <td mat-cell *matCellDef="let listItem">
          <span style="font-weight:{{listItem.lecturerEmployee ? '' : 'bold'}}">{{ listItem.lecturerEmployee ? (listItem.lecturerEmployee.firstName + ' ' + listItem.lecturerEmployee.name )
          : ('noLecturer' | translate)  }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="tuitionDate">
        <th mat-header-cell *matHeaderCellDef >{{ 'tuitionDate' | translate }}</th>
        <td mat-cell *matCellDef="let listItem">
          <span style="font-weight:{{listItem.tuition.tuitionDate ? '' : 'bold'}}">{{ listItem.tuition.tuitionDate  ?
          (listItem.tuition.tuitionDate | date) : ('noDate' | translate )}}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef >{{ 'status' | translate }}</th>
        <td mat-cell *matCellDef="let listItem">
          @switch (listItem.tuition.status) {
            @case (0) {
              <div class="status-color {{checkDate(listItem)? 'yellow' : 'red'}}" matTooltip="{{ (checkDate(listItem)? 'open' : 'overdue') | translate }}"></div>
            }
            @case (1) {
              <div class="status-color green" matTooltip="{{ 'completed' | translate }}"></div>
            }
            @case (2) {
              <div class="status-color red" matTooltip="{{ 'canceled' | translate }}"></div>
            }
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="participantsInfo">
        <th mat-header-cell *matHeaderCellDef>{{ 'signedParticipants' | translate }}</th>
        <td mat-cell *matCellDef="let listItem">
          <span>{{ getParticipantInfo(listItem) }}</span>
        </td>
      </ng-container>


      <ng-container matColumnDef="options">
        <th mat-header-cell *matHeaderCellDef>{{ 'options' | translate }}</th>
        <td mat-cell *matCellDef="let listItem">
          @if (listItem.tuition.status === 0) {
            <button mat-icon-button (click)="finish($event, listItem.tuition)"
              matTooltip="{{ 'finish' | translate }}">
              <mat-icon class="isCheckIcon">check</mat-icon>
            </button>
          }
          <button mat-icon-button (click)="openTuitionDetails($event,listItem)"
            matTooltip="{{ 'edit' | translate }}">
            <mat-icon class="editIcon">edit</mat-icon>
          </button>
          <button mat-icon-button (click)="openDeleteDialog($event,listItem)"
            matTooltip="{{ 'delete' | translate }}">
            <mat-icon class="deleteIcon">delete</mat-icon>
          </button>
          <button mat-icon-button (click)="openPrint($event, listItem)" matTooltip="{{ 'print' | translate }}">
            <mat-icon class="printIcon">print</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
      <tr mat-row class="selectable" *matRowDef="let row; columns: tableColumns;" (click)="openInNewTab(row)"></tr>
    </table>
    <mat-paginator class="mat-paginator-sticky" [pageSize]="checkPageSize()" [pageSizeOptions]="pageSizeOptions"
    [length]="totalCount" [showFirstLastButtons]="true" (page)="pageChange($event)"></mat-paginator>
  </div>
  @if (!dataSource.data.length && !loading) {
    <saf-empty-message
    (reloadClicked)="reloadTable()"></saf-empty-message>
  }

  @if (!config.onlyForDetails) {
    <div mat-dialog-actions align="end">
      <button mat-raised-button class="administration deleteButtonHover" color="primary"
        (click)="cancel()">{{ 'cancel' | translate }}
      </button>
      @if (dataSource.data.length) {
        <button mat-raised-button class="administration saveButtonHover" (click)="submit()"
          color="primary">{{ 'save' | translate }}
        </button>
      }
    </div>
  }
  @if (config.onlyForDetails) {
    <div mat-dialog-actions align="end">
      <button mat-raised-button class="administration deleteButtonHover" color="primary"
        (click)="cancel()">{{ 'cancel' | translate }}
      </button>
    </div>
  }
</div>
